module.exports = __webpack_public_path__ + "static/media/restaurant.93499397.svg";